<template>
  <div v-if="isShow" class="ov on" @click.self="close">
    <div class="dlg" role="dialog" aria-labelledby="add-offer-title" @click.stop>
      <div class="dwh">
        <div>
          <div id="add-offer-title" class="dwt">Add Offer</div>
          <span class="dws">Associate a global offer, or create a blank offer on this ad set</span>
        </div>
        <span class="grow"></span>
        <button type="button" class="dwx" @click="close">✕</button>
      </div>
      <div class="dwb">
        <div class="grp">
          <div class="grph">Global offer</div>
          <div class="grpb one">
            <div class="fd wide">
              <label>Search by offer ID</label>
              <input class="ti" type="text" v-model.trim="offerId" @keyup="getOfferDetailsByID" placeholder="Offer ID">
              <span v-if="offerName" class="hint">{{ offerName }}</span>
            </div>
            <div class="fd wide">
              <label>Advertiser</label>
              <select class="ti" :value="advertiserForm.adv_id" @change="onAdvChange">
                <option :value="0">Select advertiser</option>
                <option v-for="a in advRows" :key="a.value" :value="a.value">{{ a.text }}</option>
              </select>
            </div>
            <div v-if="advertiserForm.adv_id !== 0" class="fd wide" style="position:relative">
              <label>Global offer</label>
              <input class="ti" type="text" v-model.trim="selectedOffer" @keyup="autoc" @focus="autoc" placeholder="Type to search">
              <div class="autoc" v-if="show_autoc">
                <div v-for="row in autoc_res" :key="row" class="autoc_item" @click="autoc_select">{{ row }}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="dwf">
        <button class="btn" type="button" :disabled="busy" @click="addManual">Add Manual offer</button>
        <span class="grow"></span>
        <button class="btn" type="button" :disabled="busy" @click="close">Cancel</button>
        <button class="btn primary" type="button" :disabled="busy || !canAssoc" @click="submit">Associate</button>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    isShow: {},
    shouldUpdate: {},
    placement: {},
    campId: { default: 0 },
    isVtaRoute: { default: false },
  },
  data() {
    return {
      advertiserForm: {
        adv_id: 0,
        global_offer_id: 0,
      },
      offerId: '',
      offerName: '',
      selectedOffer: '',
      globalOfferRows: [],
      advRows: [],
      autoc_res: [],
      show_autoc: false,
      newGlobalOfferIdMin: 40000,
      busy: false,
    }
  },
  computed: {
    canAssoc() {
      return (this.advertiserForm.adv_id !== 0 && this.selectedOffer.length !== 0) || this.offerName.length !== 0
    },
  },
  watch: {
    isShow(v) {
      if (v) this.setDefault()
    },
  },
  async created() {
    await this.getData()
  },
  methods: {
    close() {
      if (this.busy) return
      this.setDefault()
      this.$emit('update:is-show', false)
    },
    onAdvChange(e) {
      const advId = Number(e.target.value) || 0
      this.advertiserForm.adv_id = advId
      this.advertiserForm.global_offer_id = 0
      this.selectedOffer = ''
      this.globalOfferRows = []
      this.show_autoc = false
      if (advId) this.getGlobalOfferByAdvId(advId)
    },
    isNewGlobalOfferId(id) {
      return Number(id) >= this.newGlobalOfferIdMin
    },
    rowLabel(offerObj) {
      if (this.isNewGlobalOfferId(offerObj.id)) {
        return `${offerObj.id} - ${offerObj.name}`
      }
      return offerObj.name
    },
    resolveAssocOfferId() {
      const typedId = String(this.offerId || '').trim()
      if (/^\d+$/.test(typedId) && this.isNewGlobalOfferId(typedId)) {
        return Number(typedId)
      }

      const selected = String(this.selectedOffer || '').trim()
      const newHit = this.globalOfferRows.find((r) => r.isNew && (r.label === selected || String(r.value) === selected))
      if (newHit) {
        return Number(newHit.value)
      }

      const legacyHit = this.globalOfferRows.find((r) => !r.isNew && r.text === selected)
      if (legacyHit) {
        return Number(legacyHit.value)
      }

      if (/^\d+$/.test(typedId)) {
        return Number(typedId)
      }
      if (this.advertiserForm.global_offer_id) {
        return Number(this.advertiserForm.global_offer_id)
      }
      return 0
    },
    async getData() {
      const data = await this.$http.post(this.resources.Management.getAdvertisersList)

      if (data.body.res === 'OK') {
        const res = await data.body.data
        this.advRows = res.map(advObj => {
          return {
            value: advObj.id,
            text: advObj.adv_company_name
          }
        })
      }
    },
    async getGlobalOfferByAdvId(advId) {
      const isVta = this.isVtaRoute === true || this.isVtaRoute === 1 || this.isVtaRoute === '1' || this.isVtaRoute === 'true'
      const data = await this.$http.post(this.resources.Management.getGlobalOffersByAdvertise(advId, isVta))
      if (data.body.res === 'OK') {
        if (data.body.data !== null) {
          const res = await data.body.data
          this.globalOfferRows = res.map(offerObj => {
            const isNew = this.isNewGlobalOfferId(offerObj.id)
            return {
              value: offerObj.id,
              text: offerObj.name,
              label: this.rowLabel(offerObj),
              isNew,
            }
          })
        } else {
          this.globalOfferRows = []
        }
      }
    },
    async getOfferDetailsByID(e) {
      if (e && e.preventDefault) e.preventDefault()
      const rawId = String(this.offerId || '').trim()
      if (!rawId) {
        this.notifyError(`Please enter offer ID`)
        return
      }
      if (!/^\d+$/.test(rawId)) {
        return
      }
      if (e && e.key !== 'Enter' && rawId.length < 3) {
        return
      }
      try {
        const res = await this.$http.get(this.resources.GlobalOffers.fetchGlobalOfferById(rawId))
        const data = await res.json()
        if (data.res !== 'OK' || !data.data || data.data.affiseID === 0) {
          this.notifyError(`Offer ${rawId} does not exist.`)
          this.offerId = ''
          return
        }

        const offerData = data.data
        if (!offerData.is_global_offer) {
          this.notifyError(`Offer ${offerData.name} is not global.`)
          this.offerId = ''
          return
        }

        if (offerData.advertiser_id === 0) {
          this.notifyError(`Offer ${offerData.name} has no related advertiser.`)
          this.offerId = ''
          return
        }
        this.offerName = offerData.name
        this.advertiserForm.adv_id = offerData.advertiser_id
        this.advertiserForm.global_offer_id = Number(rawId)
        await this.getGlobalOfferByAdvId(this.advertiserForm.adv_id)
        this.selectedOffer = this.isNewGlobalOfferId(rawId)
          ? `${rawId} - ${offerData.name}`
          : offerData.name
      } catch (err) {
        this.notifyError(err)
      }
    },
    async submit() {
      const globalOfferId = this.resolveAssocOfferId()
      if (!globalOfferId || this.advertiserForm.adv_id === 0) {
        this.notifyError('Please select advertiser and global offer . ')
        return
      }
      this.advertiserForm.global_offer_id = globalOfferId

      const typedId = String(this.offerId || '').trim()
      if (!this.isNewGlobalOfferId(globalOfferId) && !typedId) {
        const inList = this.globalOfferRows.some((r) => !r.isNew && Number(r.value) === globalOfferId)
        if (!inList) {
          this.notifyError('Please select global offer from the list. ')
          return
        }
      }
      if (this.advertiserForm.global_offer_id === undefined || this.advertiserForm.global_offer_id === 0) {
        this.notifyError('An error occured ! ')
        return
      }
      this.busy = true
      try {
        const res = await this.$http.get(this.resources.GlobalOffers.fetchGlobalOfferById(this.advertiserForm.global_offer_id))
        const oData = (res && res.body) || (await res.json())
        if (!oData || oData.res !== 'OK' || !oData.data) {
          this.notifyError((oData && oData.data) ? String(oData.data) : `Offer ${this.advertiserForm.global_offer_id} could not be loaded.`)
          return
        }
        const offer = oData.data || {}
        let offerGeo
        const geoRaw = offer.geo == null ? '' : String(offer.geo)
        if (geoRaw.length === 0) {
          offerGeo = []
        } else {
          offerGeo = geoRaw.split(',').map((g) => g.trim()).filter(Boolean)
        }

        const placement = this.placement || {}
        const placementGeo = Array.isArray(placement.geo)
          ? placement.geo
          : String(placement.geo || '').split(',').map((g) => g.trim()).filter(Boolean)
        const isGeoMatch = await this.compare(placementGeo, offerGeo)
        if (!isGeoMatch) {
          this.notifyError(
            `Please make sure location targeting is the same for the global offer and the adset and try again. (offer: ${offerGeo.join(',') || '—'}, adset: ${placementGeo.join(',') || '—'})`
          )
          return
        }

        const adSetId = Number((this.placement && this.placement.id) || this.$route.params.placementId)
        if (!Number.isFinite(adSetId) || adSetId <= 0) {
          this.notifyError('No ad set selected.')
          return
        }

        const data = await this.$http.post(
          this.resources.Management.assocGlobalOfferToAdSet(
            this.advertiserForm.global_offer_id,
            adSetId
          )
        )
        if (data.body.res === 'OK') {
          if (data.body.data !== 0) {
            this.$emit('shouldUpdate')
            this.notifySuccess('Global offer has successfully created on ad set .')
          }
          this.setDefault()
          this.$emit('update:is-show', false)
        } else {
          const detail = data.body && data.body.data
          this.notifyError(detail ? String(detail) : 'An error occured ! ')
        }
      } catch (err) {
        const detail =
          (err && err.body && err.body.data) ||
          (err && err.bodyText) ||
          (err && err.message)
        this.notifyError(detail ? String(detail) : 'An error occured ! ')
      } finally {
        this.busy = false
      }
    },
    async addManual() {
      const campId = Number(this.campId || (this.$route && this.$route.params && this.$route.params.campId))
      const adSetId = Number((this.placement && this.placement.id) || this.$route.params.placementId)
      if (!Number.isFinite(campId) || campId <= 0 || !Number.isFinite(adSetId) || adSetId <= 0) {
        this.notifyError('No ad set selected.')
        return
      }
      const placement = this.placement || {}
      const rotating = !!(placement.use_offer_rotation || placement.is_offers_rotation)
      const hasOffers = ((placement.offers || []).length > 0) || Number(placement.current_selected_offer) !== 0
      const form = {
        affiseID: 0,
        name: '',
        weight: rotating && hasOffers ? 0 : 100,
        auto_adjustment_weight_enabled: false,
        cap: 0,
        frq: 24,
        ip_frq: 24,
        ip_frq_level: 'l3',
        pid: null,
        subs_query: null,
        custom_url: null,
        os_version: null,
        connection_type: 'all',
        isps: [],
        blFiles: [],
        blacklisting_subs: [],
        ttl: 6,
        is_rotating: 1,
        delivery_frq: 100,
        traffic_in_app: 1,
        traffic_mobile: 1,
        creative_tag: 1,
        creative_img: 1,
        exclude_offer_rotation: false,
        is_global_offer_pid_rotating: false,
        is_global_offer_new_pid_rotating: 0,
        click_offer: null,
        is_global_offer: false,
        is_new_pid: '1',
        advertiser_id: 0,
        is_device_id_traffic: false,
        region: '',
        advertiser_requests: '',
        sl_comments: '',
      }
      this.busy = true
      try {
        const r = await this.$http.post(this.resources.SmartLinksCampaigns.postOffer(campId, adSetId), form)
        const data = r.body && (r.body.offer_id != null || r.body.res) ? r.body : (typeof r.json === 'function' ? await r.json() : r)
        const offerId = Number(data && data.offer_id)
        if (!offerId) {
          this.notifyError('Could not create offer')
          return
        }
        this.setDefault()
        this.$emit('update:is-show', false)
        this.$emit('created', offerId)
        this.notifySuccess('Offer created')
      } catch (err) {
        this.notifyError('Could not create offer')
      } finally {
        this.busy = false
      }
    },
    autoc: async function(e) {
      if (this.globalOfferRows.length === 0) {
        return
      }
      this.autoc_res = []
      const needle = (e && e.target && e.target.value != null) ? e.target.value : this.selectedOffer
      const needleLower = String(needle || '').toLowerCase()
      for (const k in this.globalOfferRows) {
        const row = this.globalOfferRows[k]
        if (row.isNew) {
          if (String(row.value).startsWith(needle) || row.label.toLowerCase().startsWith(needleLower)) {
            this.autoc_res.push(row.label)
          }
        } else if (row.text.startsWith(needle)) {
          this.autoc_res.push(row.label)
        }
      }
      this.show_autoc = this.autoc_res.length > 0
    },
    autoc_select: function(e) {
      this.show_autoc = false
      this.selectedOffer = e.target.innerHTML.trim()
      const hit = this.globalOfferRows.find((r) => r.label === this.selectedOffer)
      if (hit) {
        this.advertiserForm.global_offer_id = hit.value
        if (hit.isNew) {
          this.offerId = String(hit.value)
        }
      }
    },
    async compare(array1, array2) {
      const norm = (arr) => (arr || []).map((g) => String(g || '').trim().toUpperCase()).filter(Boolean).sort()
      const a = norm(array1)
      const b = norm(array2)
      if (a.length != b.length) {
        return false
      }
      for (let i = 0; i < a.length; i++) {
        if (a[i] != b[i]) {
          return false
        }
      }
      return true
    },
    setDefault() {
      this.advertiserForm.adv_id = 0
      this.advertiserForm.global_offer_id = 0
      this.offerId = ''
      this.offerName = ''
      this.selectedOffer = ''
      this.globalOfferRows = []
      this.autoc_res = []
      this.show_autoc = false
    }
  },
}
</script>
